import React from 'react';
import createSvgIcon from '../createSvgIcon';

export default createSvgIcon(
  <path d="M3.3 9.3C2.9 9.7 2.9 10.3 3.3 10.7C3.7 11.1 4.3 11.1 4.7 10.7L8 7.4 11.3 10.7C11.7 11.1 12.3 11.1 12.7 10.7C13.1 10.3 13.1 9.7 12.7 9.3L8.7 5.3C8.3 4.9 7.7 4.9 7.3 5.3L3.3 9.3Z" />,
  'ArrowUp',
);
